export default (str, size = 'default') => {
  let charlen = size === 'large' ? 20 : 13
  let result = str.replace(
    new RegExp(`(?![^\\n]{1,${charlen}}$)([^\\n]{1,${charlen}})\\s`, 'g'), '$1::newline::'
  )

  if (result) {
    return result.split('::newline::')
  } else {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/charts/StrSplitter.js